var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckboxSelBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_checkbox_sel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18.5 0C8.55887 0 0.5 8.05887 0.5 18C0.5 27.9411 8.55887 36 18.5 36C28.4411 36 36.5 27.9411 36.5 18C36.5 8.05887 28.4411 0 18.5 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M25.3165 11.7287L14.9892 22.2103L10.6966 17.904C10.1588 17.3662 9.28692 17.3662 8.74915 17.904C8.21138 18.4418 8.21138 19.3137 8.74915 19.8514L14.0154 25.1177C14.2729 25.3774 14.6235 25.5234 14.9892 25.5234C15.3548 25.5234 15.7054 25.3774 15.9629 25.1177L27.3188 13.6213C27.8566 13.0835 27.8566 12.2116 27.3188 11.6738C26.781 11.1361 25.9091 11.1361 25.3714 11.6738L25.3165 11.7287Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckboxSelBlack);
export default __webpack_public_path__ + "static/media/ic_checkbox_sel_black.3b563a6beb8ba976858fbc4526053c5b.svg";
export { ForwardRef as ReactComponent };